module.exports = __webpack_public_path__ + "img/nonghang-icon.ca7d1341.png";